module.exports = __webpack_public_path__ + "static/media/zoom-close.81512e2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/zoom-close.svg
// module id = 2446
// module chunks = 0